import Navbar from "./Components/Navbar/Navbar";
import HomePage from "./Pages/HomePage/HomePage";

function App() {
  return (
    <div>
      <Navbar />
      <HomePage />
    </div>
  );
}

export default App;
